/**
 * Maps a verifySubscription outcome to the user-visible reaction: which toast
 * to show and whether the session is stale (needs re-authentication).
 *
 * Kept separate from the React handler so the decision is unit testable and the
 * "lapsed session prompts re-auth" behaviour can't silently regress.
 */

import type { VerifyOutcome } from './verifySubscription';

export interface VerifyUiEffect {
  toast: {
    kind: 'success' | 'warning' | 'default';
    title: string;
    description: string;
  };
  /** The session is stale — mark authStale (surfaces the re-logon prompt). */
  markStale: boolean;
}

export function verifyOutcomeToEffect(outcome: VerifyOutcome): VerifyUiEffect {
  switch (outcome) {
    case 'verified':
      return {
        toast: {
          kind: 'success',
          title: 'Subscription verified',
          description: 'Your Pro access is up to date.',
        },
        markStale: false,
      };
    case 'needs-signin':
      return {
        toast: {
          kind: 'warning',
          title: 'Session expired',
          description: 'Please sign in again to verify your subscription.',
        },
        markStale: true,
      };
    case 'error':
    default:
      return {
        toast: {
          kind: 'default',
          title: "Couldn't verify subscription",
          description: 'Please check your connection and try again.',
        },
        markStale: false,
      };
  }
}
